import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import vocRatings from "../../../../src/data/articles/cube-prospective-crimson-vow-commander/voc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  vocRatings,
  ProspectiveIntro,
  React
};